import AuthenticationService from "application/modules/authentication/AuthenticationService";

const getCallCenterConfigurationsMenu = () => {
  try {
    const groupMenu = AuthenticationService.getGroupMenus?.() || [];

    if (!Array.isArray(groupMenu)) return [];

    return groupMenu
      .map((item) => item?.CallCenterConfigurationsMenu || [])
      .filter(Array.isArray)
      .flat()
      .filter((menu) => menu && typeof menu === "object")
      .map((menu) => ({
        icon: menu?.icon || "",
        key: menu?.key || "",
        name: menu?.menuName || "",
        url: menu?.url || "",
        productionReady: menu?.productionReady ?? false,
        description: menu?.description || "",
      }));
  } catch (err) {
    console.error("Error generating dynamic Call Center Configuration menus:", err);
    return [];
  }
};

export { getCallCenterConfigurationsMenu };
